import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiStateService {

  private elements: any = {};


  public get(name: string): any {
    return this.elements[name];
  }

  public set(name: string, value: any): void {
    this.elements[name] = value;
  }


}


